module.exports = __webpack_public_path__ + "img/attach-doc-pdf.cdda78f0.svg";